import { QuestionVariety } from "./Definition";
import { SingleValueQuestion } from "./SingleValueQuestion";

export default class SelectSingleQuestion extends SingleValueQuestion {
  get type(): QuestionVariety {
    return "select_single";
  }
}
